import { render, staticRenderFns } from "./spread-longer.vue?vue&type=template&id=dbfd0b7e&scoped=true"
import script from "./spread-longer.vue?vue&type=script&lang=js"
export * from "./spread-longer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfd0b7e",
  null
  
)

export default component.exports